/** @format */
import { ReactElement, ReactNode } from 'react';

export type ProductTrustCardProps = {
    heading: string;
    icon: ReactElement;
    children: ReactNode;
    'data-testid'?: string;
    className?: string;
    variant?: ProductTrustCardVariant;
    withKeyline?: boolean;
};

export type ProductTrustCardSkeletonProps = {
    className?: string;
    'data-testid'?: string;
    children?: ReactNode;
};

export enum ProductTrustCardVariant {
    SUN = 'SUN',
    WHITE = 'WHITE',
}

export type StyledProductTrustCardProps = Pick<
    ProductTrustCardProps,
    'data-testid' | 'className' | 'variant'
>;
